export function MemberContributions() {
  return {
    min: 0,
    '20%': 2,
    '30%': 3,
    '40%': 4,
    '50%': 5,
    '60%': 6,
    '70%': 7,
    '80%': 8,
    '90%': 9,
    max: 10,
  };
}

export function FiveHundredThousand(step) {
  return {
    min: 0,
    '25%': [13000, step],
    '50%': [75000, step],
    max: 500000,
  };
}

export function OneMillion(step) {
  return {
    min: 0,
    '25%': [25000, step],
    '50%': [150000, step],
    max: 1000000,
  };
}

export function TwoMillion(step) {
  return {
    min: 0,
    '25%': [50000, step],
    '50%': [300000, step],
    max: 2000000,
  };
}
